import {change} from "redux-form";
import {UPDATED_FORM} from "./types";

export const updateForm=(formName,fieldName,value)=>{
    return async (dispatch) => {
        change(formName,fieldName,value);
        dispatch({type: UPDATED_FORM });
    }
}
